module.exports = __webpack_public_path__ + "img/Z81_14.739073f0.jpg";